package com.veldekar.components.log

import kotlin.collections.List
import kotlin.collections.listOf
import kotlinx.datetime.LocalDate

/**
 * List of all session data, sorted in chronological order (oldest first).
 * Use .reversed() to get newest first.
 */
public val sessions: List<SessionListData> = listOf(
            SessionListData.Full(
                path = "/2023-01-14",
                title = "Introduction at the Leering Stag",
                description = "Heroes gather at the Leering Stag inn, introducing themselves and taking a contract to find missing brothers.",
                imageUrl = "ai/2023-01-14_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_023, 1, 14),
                veldekarDates = listOf("newgrowth-8", "newgrowth-9"),
            ),
            SessionListData.Full(
                path = "/2023-01-20",
                title = "The Investigation Begins",
                description = "The party investigates the Crond brothers' home and searches for missing guards near a mysterious ridge.",
                imageUrl = "ai/2023-01-20_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_023, 1, 20),
                veldekarDates = listOf("newgrowth-9", "newgrowth-10"),
            ),
            SessionListData.Full(
                path = "/2023-01-27",
                title = "Gnolls and Cultists",
                description = "After slaying a group of Gnolls, the heroes encounter and interrogate cultists worshipping the demon Sklyx.",
                imageUrl = "ai/2023-01-27_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_023, 1, 27),
                veldekarDates = listOf("newgrowth-11", "newgrowth-12"),
            ),
            SessionListData.Full(
                path = "/2023-02-17",
                title = "The Cave of the Abyss",
                description = "The heroes infiltrate a cave, defeat a demonic creature, and recover a magical triangle shard and lost guards.",
                imageUrl = "ai/2023-02-17_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_023, 2, 17),
                veldekarDates = listOf("newgrowth-12"),
            ),
            SessionListData.Full(
                path = "/2023-03-03",
                title = "The Shield Bearers' Quest",
                description = "The party joins a guild dedicated to repairing the Shield of Concar and prepares to brave the Imperial Darkway.",
                imageUrl = "ai/2023-03-03_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_023, 3, 3),
                veldekarDates = listOf("newgrowth-16", "newgrowth-17"),
            ),
            SessionListData.Full(
                path = "/2023-03-10",
                title = "Falorn Joins and Ankhegs Rise",
                description = "Falorn joins the party as they embark toward Dorb, only to be ambushed by a massive Ankheg monstrosity.",
                imageUrl = "ai/2023-03-10_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_023, 3, 10),
                veldekarDates = listOf("newgrowth-17", "newgrowth-18"),
            ),
            SessionListData.Full(
                path = "/2023-03-17",
                title = "Ankhegs Defeated",
                description = "The heroes emerge victorious against the Ankhegs, though Falorn is left disappointed by the lack of gold.",
                imageUrl = "ai/2023-03-17_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_023, 3, 17),
                veldekarDates = listOf("newgrowth-18"),
            ),
            SessionListData.Full(
                path = "/2023-03-24",
                title = "A Visit from Lalia",
                description = "After a strange encounter with a statue of Gildora, the heroes are visited by the Erinyes Lalia with a warning.",
                imageUrl = "ai/2023-03-24_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_023, 3, 24),
                veldekarDates = listOf("newgrowth-18", "newgrowth-19", "newgrowth-21"),
            ),
            SessionListData.Full(
                path = "/2023-03-31",
                title = "Trouble in Blave",
                description = "Arriving in Blave, the heroes learn of Hill Giants and Ettins harassing the region's military outposts.",
                imageUrl = "ai/2023-03-31_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_023, 3, 31),
                veldekarDates = listOf("newgrowth-21", "newgrowth-22", "newgrowth-23"),
            ),
            SessionListData.Full(
                path = "/2023-04-14",
                title = "Repelling the Giant Ambush",
                description = "The party repels an orc and giant ambush before arriving in Dorb to meet with high-level military officers.",
                imageUrl = "ai/2023-04-14_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_023, 4, 14),
                veldekarDates = listOf("newgrowth-23"),
            ),
            SessionListData.Full(
                path = "/2023-05-12",
                title = "Mission to Malus",
                description = "Tuesday acquires a magical cloak, and the party is tasked by the Peers to secure the shield shard in Malus.",
                imageUrl = "ai/2023-05-12_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_023, 5, 12),
                veldekarDates = listOf("newgrowth-24", "newgrowth-25"),
            ),
            SessionListData.Full(
                path = "/2023-05-19",
                title = "Entering the Darkway",
                description = "The heroes enter the Malusian Imperial Darkway, facing Vrocks in an abandoned guard outpost deep underground.",
                imageUrl = "ai/2023-05-19_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_023, 5, 19),
                veldekarDates = listOf("newgrowth-26", "newgrowth-27", "newgrowth-28"),
            ),
            SessionListData.Full(
                path = "/2023-05-26",
                title = "Battle in the Stables",
                description = "A Beholder-like Spectator and more Vrocks ambush the party in the Darkway, forcing a desperate magical defense.",
                imageUrl = "ai/2023-05-26_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_023, 5, 26),
                veldekarDates = listOf("newgrowth-28"),
            ),
            SessionListData.Full(
                path = "/2023-06-02",
                title = "Treasure and Tunnels",
                description = "After clearing the outpost of demons, the heroes discover a massive hoard of gold and powerful magical artifacts.",
                imageUrl = "ai/2023-06-02_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_023, 6, 2),
                veldekarDates = listOf("newgrowth-28", "newgrowth-29"),
            ),
            SessionListData.Full(
                path = "/2023-06-09",
                title = "The Carnage Crew",
                description = "The heroes are carpet-bombed by the mysterious Carnage Crew, leading to a pointer toward their location.",
                imageUrl = "ai/2023-06-09_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_023, 6, 9),
                veldekarDates = listOf("newgrowth-29"),
            ),
            SessionListData.Full(
                path = "/2023-06-16",
                title = "River Cave Ingress",
                description = "Joined by dwarves Shail and Dworlan, the party takes boats into an echoing river cave system beneath the mountains.",
                imageUrl = "ai/2023-06-16_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_023, 6, 16),
                veldekarDates = listOf("newgrowth-29", "newgrowth-30"),
            ),
            SessionListData.Full(
                path = "/2023-06-23",
                title = "Yuan-ti Ambush",
                description = "In the dark caverns, the heroes battle powerful Yuan-ti serpent-folk, including a Pitmaster and an Anathema.",
                imageUrl = "ai/2023-06-23_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_023, 6, 23),
                veldekarDates = listOf("newgrowth-30"),
            ),
            SessionListData.Full(
                path = "/2023-06-30",
                title = "Shrine to Silpion",
                description = "After looting the Yuan-ti, the party continues downstream and discovers a shrine to the water goddess Silpion.",
                imageUrl = "ai/2023-06-30_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_023, 6, 30),
                veldekarDates = listOf("newgrowth-30", "newgrowth-31"),
            ),
            SessionListData.Full(
                path = "/2023-07-14",
                title = "The Whirlpool's Grasp",
                description = "Disaster strikes as the boats capsize in a magical whirlpool, and grasping tendrils drag the heroes into the water.",
                imageUrl = "ai/2023-07-14_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_023, 7, 14),
                veldekarDates = listOf("newgrowth-31"),
            ),
            SessionListData.Full(
                path = "/2023-07-21",
                title = "Battle with the Aboleth",
                description = "The heroes face the dread Aboleth Flar’Melkhis in the river, narrowly escaping its charms and mind-virus.",
                imageUrl = "ai/2023-07-21_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_023, 7, 21),
                veldekarDates = listOf("newgrowth-31"),
            ),
            SessionListData.Full(
                path = "/2023-07-28",
                title = "Traps and Hobgoblins",
                description = "After resting, the party navigates a heavily trapped tunnel and engages a vanguard of hostile Hobgoblins.",
                imageUrl = "ai/2023-07-28_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_023, 7, 28),
                veldekarDates = listOf("newgrowth-32"),
            ),
            SessionListData.Full(
                path = "/2023-08-04",
                title = "Ambush of the Venom Trolls",
                description = "The heroes are ambushed by Goblinoids and Venom Trolls in an overgrown ruin, leading to a chaotic, bloody battle.",
                imageUrl = "ai/2023-08-04_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_023, 8, 4),
                veldekarDates = listOf("newgrowth-32"),
            ),
            SessionListData.Full(
                path = "/2023-08-11",
                title = "Tides Turn in the Ambush",
                description = "The heroes rally against the Venom Trolls and Hobgoblins, utilizing fire and steel to decimate the fleeing enemy.",
                imageUrl = "ai/2023-08-11_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_023, 8, 11),
                veldekarDates = listOf("newgrowth-32"),
            ),
            SessionListData.Full(
                path = "/2023-08-18",
                title = "The Green Dragon Sylus",
                description = "Emerging from the caves, the heroes spot the green dragon Sylus and attempt to hide as they travel through his valley.",
                imageUrl = "ai/2023-08-18_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_023, 8, 18),
                veldekarDates = listOf("newgrowth-32", "newgrowth-33", "newgrowth-34", "newgrowth-35", "newgrowth-36"),
            ),
            SessionListData.Full(
                path = "/2023-08-25",
                title = "Escape to Malus",
                description = "After deceiving Sylus, the heroes reach the imperial city of Malus and visit the legendary Traveler’s Doorstep.",
                imageUrl = "ai/2023-08-25_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_023, 8, 25),
                veldekarDates = listOf("newgrowth-36", "newgrowth-37"),
            ),
            SessionListData.Full(
                path = "/2023-09-01",
                title = "Top Secret Counsel",
                description = "The heroes meet with city leadership to discuss the alignment between Sylus and Lalia and a new shard in Zedj.",
                imageUrl = "ai/2023-09-01_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_023, 9, 1),
                veldekarDates = listOf("newgrowth-37"),
            ),
            SessionListData.Full(
                path = "/2023-11-19",
                title = "Gem Shopping and Spies",
                description = "While shopping for crafting gems, Bigglesworth detects a spy following them to a mercenary headquarters.",
                imageUrl = "ai/2023-11-19_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_023, 11, 19),
                veldekarDates = listOf("newgrowth-37"),
            ),
            SessionListData.Full(
                path = "/2023-12-08",
                title = "Disguises and Reports",
                description = "Falorn explains his desertion from The Fist, while the party encounters the Carnage Crew again in the city streets.",
                imageUrl = "ai/2023-12-08_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_023, 12, 8),
                veldekarDates = listOf("newgrowth-38", "newgrowth-39"),
            ),
            SessionListData.Full(
                path = "/2023-12-15",
                title = "Hexagon Battle Open",
                description = "The heroes attend a combat competition where Annette spots a member of the Carnage Crew hiding in the crowd.",
                imageUrl = "ai/2023-12-15_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_023, 12, 15),
                veldekarDates = listOf("newgrowth-39"),
            ),
            SessionListData.Full(
                path = "/2023-12-22",
                title = "Portal to Zedj",
                description = "After winning bets at the Hexagon Battle, the heroes teleport through a portal to begin their journey to Zedj.",
                imageUrl = "ai/2023-12-22_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_023, 12, 22),
                veldekarDates = listOf("newgrowth-39", "newgrowth-40"),
            ),
            SessionListData.Full(
                path = "/2024-01-26",
                title = "Vision of Entor",
                description = "On the road to Zedj, the heroes defeat disguised Slaad and receive a divine vision of two items needed for the shield.",
                imageUrl = "ai/2024-01-26_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_024, 1, 26),
                veldekarDates = listOf("newgrowth-40"),
            ),
            SessionListData.Full(
                path = "/2024-02-02",
                title = "Fiendish Incidents",
                description = "The heroes visit a shrine of Doriath, meet Lalia again, and learn of fiendish attacks plagueing the towns near Zedj.",
                imageUrl = "ai/2024-02-02_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_024, 2, 2),
                veldekarDates = listOf("newgrowth-41", "newgrowth-42", "newgrowth-43", "newgrowth-44", "newgrowth-45"),
            ),
            SessionListData.Full(
                path = "/2024-02-23",
                title = "The Compound Eye",
                description = "In Dunstone, the party tracks down Dolly Mott to retrieve a violet gem known as the 'compound eye'.",
                imageUrl = "ai/2024-02-23_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_024, 2, 23),
                veldekarDates = listOf("newgrowth-45"),
            ),
            SessionListData.Full(
                path = "/2024-03-01",
                title = "The Siege of Cark",
                description = "The heroes call in the Malusian army to break a siege of giants and orcs at the town of Cark.",
                imageUrl = "ai/2024-03-01_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_024, 3, 1),
                veldekarDates = listOf("newgrowth-45", "newgrowth-46"),
            ),
            SessionListData.Full(
                path = "/2024-03-08",
                title = "Cark Liberated",
                description = "The Malusian army and the heroes successfully liberate Cark, though a mysterious Slaad manages to escape.",
                imageUrl = "ai/2024-03-08_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_024, 3, 8),
                veldekarDates = listOf("newgrowth-46"),
            ),
            SessionListData.Full(
                path = "/2024-03-15",
                title = "Ambush on the Road",
                description = "The Carnage Crew and Dolly Mott ambush the heroes on the road to Zedj, leading to a fierce nighttime battle.",
                imageUrl = "ai/2024-03-15_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_024, 3, 15),
                veldekarDates = listOf("newgrowth-46", "newgrowth-47"),
            ),
            SessionListData.Full(
                path = "/2024-04-05",
                title = "Incriminating Notes",
                description = "After defeating the ambushers, the heroes find a note linking the Duke of Brij to the mysterious attacks.",
                imageUrl = "ai/2024-04-05_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_024, 4, 5),
                veldekarDates = listOf("newgrowth-47"),
            ),
            SessionListData.Full(
                path = "/2024-04-12",
                title = "Arrival in Zedj",
                description = "The heroes reach Zedj and learn of a dragon landing nearby, while Tuesday chats with a local raccoon named Dax.",
                imageUrl = "ai/2024-04-12_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_024, 4, 12),
                veldekarDates = listOf("newgrowth-47", "newgrowth-49", "newgrowth-50", "newgrowth-51"),
            ),
            SessionListData.Full(
                path = "/2024-04-19",
                title = "Marilith Rampage",
                description = "Two Marilith demons attack the party in Zedj, and Tuesday transforms his allies into T-Rexes to crush them.",
                imageUrl = "ai/2024-04-19_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_024, 4, 19),
                veldekarDates = listOf("newgrowth-51"),
            ),
            SessionListData.Full(
                path = "/2024-04-26",
                title = "Subterranean Cavern",
                description = "The heroes descend into a subterranean cavern, triggering traps and engaging Hezrou warriors in the depths.",
                imageUrl = "ai/2024-04-26_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_024, 4, 26),
                veldekarDates = listOf("newgrowth-51"),
            ),
            SessionListData.Full(
                path = "/2024-05-03",
                title = "Hezrou and Vrocks",
                description = "The heroes clear the subterranean stronghold of Hezrou and Vrocks before resting to prepare for deeper depths.",
                imageUrl = "ai/2024-05-03_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_024, 5, 3),
                veldekarDates = listOf("newgrowth-51", "newgrowth-52"),
            ),
            SessionListData.Full(
                path = "/2024-05-10",
                title = "Yochlol and Ropers",
                description = "Deeper in the cavern, the party faces Yochlol demons and Ropers in a sound-dampened environment.",
                imageUrl = "ai/2024-05-10_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_024, 5, 10),
                veldekarDates = listOf("newgrowth-52"),
            ),
            SessionListData.Full(
                path = "/2024-05-17",
                title = "The Goristro Jarb",
                description = "The heroes encounter Jarb the Ascended and the Chasme Sklyx in a lava-filled chamber, starting a brutal battle.",
                imageUrl = "ai/2024-05-17_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_024, 5, 17),
                veldekarDates = listOf("newgrowth-52"),
            ),
            SessionListData.Full(
                path = "/2024-05-24",
                title = "Shard of Concar Recovered",
                description = "After slaying Jarb, the heroes solve a mechanical puzzle to recover a shard of Concar and teleport back to Malus.",
                imageUrl = "ai/2024-05-24_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_024, 5, 24),
                veldekarDates = listOf("newgrowth-52"),
            ),
            SessionListData.Full(
                path = "/2024-07-05",
                title = "Seven Shard Locations",
                description = "The Peers return the first shard to the heroes, who now have a summary of the seven remaining shard locations.",
                imageUrl = "images/RemainingShards_small_small.webp",
                isAiText = true,
                isAiImage = false,
                imageWidth = 520,
                imageHeight = 388,
                date = LocalDate(2_024, 7, 5),
                veldekarDates = listOf("newgrowth-53"),
            ),
            SessionListData.Full(
                path = "/2024-09-27",
                title = "Dinner with Elrovir",
                description = "The heroes meet Lady Aventary's husband, Elrovir Rodiridan, and prepare for a journey toward the Brij Bridge.",
                imageUrl = "ai/2024-09-27_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_024, 9, 27),
                veldekarDates = listOf("newgrowth-53", "newgrowth-55", "newgrowth-56", "newgrowth-57"),
            ),
            SessionListData.Full(
                path = "/2024-10-11",
                title = "Brij Bridge Journey",
                description = "The party chases an escape artist and travels toward the Brij Bridge, facing Ankhegs in the badlands.",
                imageUrl = "ai/2024-10-11_small.webp",
                isAiText = true,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_024, 10, 11),
                veldekarDates = listOf("newgrowth-57", "newgrowth-58", "newgrowth-63"),
            ),
            SessionListData.Full(
                path = "/2024-12-07",
                title = "Ankhegs, get in my tummy!",
                description = "“They” say that Ankheg are the “Lobster of the Land.”",
                imageUrl = "images/lobsterBibCat_preview_small.webp",
                isAiText = false,
                isAiImage = false,
                aiHint = "Description is a joke",
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_024, 12, 7),
                veldekarDates = listOf("newgrowth-63", "newgrowth-64", "newgrowth-65", "newgrowth-66"),
            ),
            SessionListData.Full(
                path = "/2024-12-28",
                title = "Scorpions in Vor's Desert",
                description = "The Deetry family fled when faced with giant scorpions, but heroes run toward danger. The fastest of our heroes, Bigglesworth the Brave, falls in battle.",
                imageUrl = "images/bigglesworthFallsInBattleLinkPreview_small.webp",
                isAiText = false,
                isAiImage = false,
                imageWidth = 520,
                imageHeight = 272,
                date = LocalDate(2_024, 12, 28),
                veldekarDates = listOf("newgrowth-67", "newgrowth-68", "newgrowth-69"),
            ),
            SessionListData.Full(
                path = "/2025-01-04",
                title = "Arrival in Well's Bounty",
                description = "Bigglesworth survives and finds poop note.",
                imageUrl = "ai/2025-01-04_small.webp",
                isAiText = false,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_025, 1, 4),
                veldekarDates = listOf("newgrowth-69", "newgrowth-70", "newgrowth-71"),
            ),
            SessionListData.Full(
                path = "/2025-01-11",
                title = "🐫🏜️🌵🏜️🌪️🌪️🌪️🌪️🌪️",
                description = "As warned by Joral Deetry, the heroes encounter air elementals in Vor’s Desert.",
                imageUrl = "ai/2025-01-11_small.webp",
                isAiText = false,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_025, 1, 11),
                veldekarDates = listOf("newgrowth-71", "newgrowth-72", "newgrowth-73"),
            ),
            SessionListData.Full(
                path = "/2025-01-18",
                title = "“Storming” the Castle",
                description = "Unnatural lightning and winds do not deter the heroes from entering the Thardos family castle.",
                imageUrl = "ai/2025-01-18_small.webp",
                isAiText = false,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_025, 1, 18),
                veldekarDates = listOf("newgrowth-73", "newgrowth-74"),
            ),
            SessionListData.Full(
                path = "/2025-01-25",
                title = "Do’Shara, Final Boss of Desert Wing",
                description = "Heroes slaughter henchmen. Samuel Thardos, Duke of Brij, is the blue dragon.",
                imageUrl = "ai/2025-01-25_small.webp",
                isAiText = false,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_025, 1, 25),
                veldekarDates = listOf("newgrowth-74"),
            ),
            SessionListData.Full(
                path = "/2025-02-01",
                title = "Friends of the Forest",
                description = "Entor empowers the heroes to defeat Do’Shara also known as Samuel Thardos, Duke of Brij.",
                imageUrl = "ai/2025-02-01_small.webp",
                isAiText = false,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_025, 2, 1),
                veldekarDates = listOf("newgrowth-74"),
            ),
            SessionListData.Full(
                path = "/2025-02-08",
                title = "1100-year-old noble found dead",
                description = "A shadowy unnamed gang of youths from Malus break into elderly woman’s home and kill her. ",
                imageUrl = "ai/2025-02-08_small.webp",
                isAiText = false,
                isAiImage = true,
                aiHint = "Image, title, and description inaccurately reimagine the heroes' defeat of a evil dragon as a crime.",
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_025, 2, 8),
                veldekarDates = listOf("newgrowth-74"),
            ),
            SessionListData.Full(
                path = "/2025-02-15",
                title = "Identity Theft",
                description = "Do’shara the blue dragon assumes the identity of Samuel Thardos Duke of Brij, fooling his guards and subjects for years.",
                imageUrl = "ai/2025-02-15_small.webp",
                isAiText = false,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_025, 2, 15),
                veldekarDates = listOf("newgrowth-74"),
            ),
            SessionListData.Full(
                path = "/2025-02-22",
                title = "Pretty Alexander Dido",
                description = "We’ve been through the desert / To find a cow with three names / It felt good to be out of the rain",
                imageUrl = "ai/2025-02-22_small.webp",
                isAiText = false,
                isAiImage = true,
                aiHint = "Description is a reference to a song.",
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_025, 2, 22),
                veldekarDates = listOf("newgrowth-75", "newgrowth-76", "newgrowth-77"),
            ),
            SessionListData.Full(
                path = "/2025-03-01",
                title = "Moo!",
                description = "Having concluded the primary cow narrative, the heroes begin their next cow narrative.",
                imageUrl = "ai/2025-03-01_small.webp",
                isAiText = false,
                isAiImage = true,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_025, 3, 1),
                veldekarDates = listOf("newgrowth-77", "newgrowth-78"),
            ),
            SessionListData.Full(
                path = "/2025-03-15",
                title = "Democracy in Bondōvriar",
                description = "I didn’t know we had a king. I thought we were an autonomous collective.",
                imageUrl = "ai/2025-03-15_small.webp",
                isAiText = false,
                isAiImage = true,
                aiHint = "Description is a reference to Monty Python's Search for the Holy Grail",
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_025, 3, 15),
                veldekarDates = listOf("newgrowth-78", "newgrowth-79"),
            ),
            SessionListData.Full(
                path = "/2025-03-22",
                title = "#FriendsOfTheForest",
                description = "Dress like nobody’s watching; love like you’ve never been hurt. Perform music like nobody’s listening; live as a friend of the forest.",
                imageUrl = "ai/2025-03-22_small.webp",
                isAiText = false,
                isAiImage = true,
                aiHint = "Description is a joke",
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_025, 3, 22),
                veldekarDates = listOf("newgrowth-79", "newgrowth-80", "newgrowth-81", "newgrowth-82", "newgrowth-83"),
            ),
            SessionListData.Full(
                path = "/2025-03-29",
                title = "Anomalation!",
                description = "Veldekar is lousy with Slaad. And they smell funny.",
                imageUrl = "images/flags1_small.webp",
                isAiText = false,
                isAiImage = false,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_025, 3, 29),
                veldekarDates = listOf("newgrowth-83", "newgrowth-84", "newgrowth-85"),
            ),
            SessionListData.Full(
                path = "/2025-04-05",
                title = "Escalation",
                description = "The heroes have discovered that Veldekar is filled with fire resistant and even fire immune enemies. Now the dungeon master sends a golem to attack the heroes who is not just immune to damage from fire magic but is actually healed by it.",
                imageUrl = "images/TheKeyOfKarzak_small.webp",
                isAiText = false,
                isAiImage = false,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_025, 4, 5),
                veldekarDates = listOf("newgrowth-85", "newgrowth-86", "newgrowth-87"),
            ),
            SessionListData.Full(
                path = "/2025-04-12",
                title = "🦞 Shell-shocked ⚡️",
                description = "Lovecraftian lobsters mercilessly brutalized and dismembered by friends of the forest.",
                imageUrl = "images/banshirToSeshiss_small.webp",
                isAiText = false,
                isAiImage = false,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_025, 4, 12),
                veldekarDates = listOf("newgrowth-87", "newgrowth-88", "newgrowth-89"),
            ),
            SessionListData.Full(
                path = "/2025-04-19",
                title = "🐸 Shimmer Eve 🧚‍♂️",
                description = "Tune in to watch the frog drop on this Shimmer Eve spectacular!",
                imageUrl = "ai/2025-04-19_small.webp",
                isAiText = false,
                isAiImage = true,
                aiHint = "Image is a Star Wars meme reference Admiral Ackbar",
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_025, 4, 19),
                veldekarDates = listOf("newgrowth-90", "shimmer-1"),
            ),
            SessionListData.Full(
                path = "/2025-04-26",
                title = "Three Terrors of the Greatmarsh",
                description = "One, Slaad — no problem, see Bigglesworth’s bladework. Two, Highwaymen — only fools Falorn. Three, C.O.U.S. (Crustaceans Of Unusual Size) — I don’t think they exist.",
                imageUrl = "ai/2025-04-26_small.webp",
                isAiText = false,
                isAiImage = true,
                aiHint = "Title & description are a Princess Bride reference",
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_025, 4, 26),
                veldekarDates = listOf("shimmer-1", "shimmer-2", "shimmer-3", "shimmer-4"),
            ),
            SessionListData.Full(
                path = "/2025-05-03",
                title = "Woes of Home Ownership by Flar’Melkhis",
                description = "Water leaking into the basement causes a dank and moldy smell. Wild animals crawl inside and die under the floor then rot. The wet bandits vandalize your home, and try to steal your trinkets.",
                imageUrl = "ai/2025-05-03_small.webp",
                isAiText = false,
                isAiImage = true,
                aiHint = "Title and description are a joke",
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_025, 5, 3),
                veldekarDates = listOf("shimmer-5"),
            ),
            SessionListData.Full(
                path = "/2025-05-10",
                title = "The call is coming from inside the house",
                description = "Tuesday had long feared Hags. He nervously scouted the dark corners of the woods and swamps as the heroes traveled throughout Veldekar. Little did he know, Korvis was “harboring” a Sea Hag.",
                imageUrl = "ai/2025-05-10_small.webp",
                isAiText = false,
                isAiImage = true,
                aiHint = "Title & description are a joke",
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_025, 5, 10),
                veldekarDates = listOf("shimmer-5"),
            ),
            SessionListData.Full(
                path = "/2025-05-17",
                title = "Fairy Rejects Proposal of Giant Hermaphrodite Eel",
                description = "While Tuesday appreciates being seen, he could never live in a subterranean cavern. He needs to fly through the trees of the forest.",
                imageUrl = "images/beMine_small.webp",
                isAiText = false,
                isAiImage = false,
                aiHint = "Image, title, and description are a joke.",
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_025, 5, 17),
                veldekarDates = listOf("shimmer-5"),
            ),
            SessionListData.Full(
                path = "/2025-05-24",
                title = "Livin' on a Prayer in Bondōvriar",
                description = "The heroes survive Flar’Melkhis, spook a nerd, and portal-hop with pockets full of loot.",
                imageUrl = "images/tooMuchGold_small_small.webp",
                isAiText = false,
                isAiImage = false,
                aiHint = "Image show characters with money falling out of their pockets (joke). Title is a reference to the city sounding like the band name Bon Jovi.",
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_025, 5, 24),
                veldekarDates = listOf("shimmer-5", "shimmer-6"),
            ),
            SessionListData.Full(
                path = "/2025-11-08",
                title = "Street-Feet Food",
                description = "Yum yum get in my belly 🐓🐔🍜",
                imageUrl = "images/chickenFeet_preview_small.webp",
                isAiText = false,
                isAiImage = false,
                aiHint = "Title is a joke (cop humor)",
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_025, 11, 8),
                veldekarDates = listOf("shimmer-6"),
            ),
            SessionListData.Full(
                path = "/2025-11-15",
                title = "The Friends Of The Forest learn of The Bright Brothers",
                description = "Brother Roberto Chandler, Brother Thradoris “Sly” Fox, and Brother Ignacio Cole",
                imageUrl = "images/brightBrothers_preview_small.webp",
                isAiText = false,
                isAiImage = false,
                aiHint = "Image and description are a joke. The Bright Brothers are actually a group of **human** adventurers.",
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_025, 11, 15),
                veldekarDates = listOf("shimmer-6", "shimmer-7"),
            ),
            SessionListData.Full(
                path = "/2025-11-22",
                title = "Cronberry",
                description = "Lornella hands Cronberry a shot glass of vodka and whispers “just a splash of vodka and I’d love to drink you up.”",
                imageUrl = "images/crestOfThradorisFox_small.webp",
                isAiText = false,
                isAiImage = false,
                aiHint = "Description is a joke.",
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_025, 11, 22),
                veldekarDates = listOf("shimmer-8"),
            ),
            SessionListData.Full(
                path = "/2025-11-29",
                title = "Everyone Loves Entor",
                description = "DM debuts his one-man show to a packed crowd!",
                imageUrl = "images/caperAndFoxMarionette_preview_small.webp",
                isAiText = false,
                isAiImage = false,
                aiHint = "Caper and Lord Fox are not actually puppets that's a joke.",
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_025, 11, 29),
                veldekarDates = listOf("shimmer-8", "shimmer-9"),
            ),
            SessionListData.Full(
                path = "/2025-12-06",
                title = "Footsmeller Remains At Large!",
                description = "The heroes have apprehended Ludwig Voss but the dreaded Matty Footseller is loose in Freeburg, likely creeping out customers getting a pedicure at a nail salon.",
                imageUrl = "images/footsmellerCoatOfArms_preview_small.webp",
                isAiText = false,
                isAiImage = false,
                aiHint = "Image, title, and description reference a joke that the players think 'Footseller' sounds like 'Footsmeller'.",
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_025, 12, 6),
                veldekarDates = listOf("shimmer-9"),
            ),
            SessionListData.Full(
                path = "/2025-12-13",
                title = "The Quokkafication of Ludwig Voss",
                description = "Once a feared half-orc. Now adorable. Barrowmen remain baffled.",
                imageUrl = "images/quokkaInHandcuffs_preview_small.webp",
                isAiText = false,
                isAiImage = false,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_025, 12, 13),
                veldekarDates = listOf("shimmer-9"),
            ),
            SessionListData.Full(
                path = "/2026-01-03",
                title = "The Art of Circles by Tuesday Sunbottom",
                description = "“If you know the ‘animate objects’ spell and know yourself, you need not fear the results of a hundred battles.”",
                imageUrl = "images/gotAnyGrapes_small.webp",
                isAiText = false,
                isAiImage = false,
                aiHint = "Image references 'Duck Song' meme. Title and description reference 'The Art of War' (joke).",
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_026, 1, 3),
                veldekarDates = listOf("shimmer-9"),
            ),
            SessionListData.Full(
                path = "/2026-01-10",
                title = "Destiny, Danger… and a Down Payment",
                description = "The heroes face their own thoughts, shady justice, and a bastion priced like it’s cursed.",
                imageUrl = "images/freeburgBastion_preview_small.webp",
                isAiText = false,
                isAiImage = false,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_026, 1, 10),
                veldekarDates = listOf("shimmer-9", "shimmer-10"),
            ),
            SessionListData.Full(
                path = "/2026-02-07",
                title = "Meet the Former Lord… and His Two Wives",
                description = "The heroes ponder the mysteries of matrimony, architecture, and smoky auras while Bigglesworth digs for treasure and hopes for tuna.",
                imageUrl = "images/lordFoxSeniorFamilyPortrait_preview_small.webp",
                isAiText = false,
                isAiImage = false,
                aiHint = "Image, title, and description suggest the lord has multiple wives as a joke because the floor plan had an error where a room was mislabeled.",
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_026, 2, 7),
                veldekarDates = listOf("shimmer-10"),
            ),
            SessionListData.Full(
                path = "/2026-02-14",
                title = "A Bastion to Restore, A Ship to Board",
                description = "Paperwork signed, pirate hats donned, and Bigglesworth declaring, “Fish make strong. Oatmeal make… face sad.”",
                imageUrl = "images/bigglesworthCatchesFish_preview_small.webp",
                isAiText = false,
                isAiImage = false,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_026, 2, 14),
                veldekarDates = listOf("shimmer-10", "shimmer-11", "shimmer-12"),
            ),
            SessionListData.Full(
                path = "/2026-02-21",
                title = "Sailfish, Sunburn, and Sudden Demons",
                description = "Captain Leah wanted a quiet supply run. Instead she got Merrow boarders, airborne demons, and Dirk’s ongoing campaign to impress her.",
                imageUrl = "images/sailfishSurprise_preview_small.webp",
                isAiText = false,
                isAiImage = false,
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_026, 2, 21),
                veldekarDates = listOf("shimmer-13"),
            ),
            SessionListData.Full(
                path = "/2026-03-07",
                title = "Umbraxus",
                description = "From the toughest grease to the deepest stains, Umbraxus handles the hard work so you don't have to.",
                imageUrl = "images/umbraxusMop_preview_small.webp",
                isAiText = false,
                isAiImage = false,
                aiHint = "Image, title, and description are a joke about the dragon's name 'Umbraxus' sounds like a cleaning product.",
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_026, 3, 7),
                veldekarDates = listOf("shimmer-13", "shimmer-14", "shimmer-15"),
            ),
            SessionListData.Full(
                path = "/2026-03-14",
                title = "The Most Delicious City in Veldekar",
                description = "On Pi Day, the heroes reach Kostigan — a pie‑shaped city perched on a cliff, its “crust” walls protecting a filling of craftsmen, travelers, and Bigglesworth’s stash of fish.",
                imageUrl = "images/kostiganIsPie_preview_small.webp",
                isAiText = false,
                isAiImage = false,
                aiHint = "Image, title, and description are a joke about how the city had a perfectly circular map.",
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_026, 3, 14),
                veldekarDates = listOf("shimmer-15", "shimmer-16", "shimmer-17", "shimmer-18", "shimmer-20"),
            ),
            SessionListData.Full(
                path = "/2026-03-21",
                title = "Highridge Intruder",
                description = "Well, obviously we have a demon in Highridge. He’s climbin’ in your windows, he’s snatchin’ your people up, tryin’ to corrupt ‘em. So y’all need to hide your kids, hide your wife, and hide your husband cause they’re grabbin’ everybody out here.",
                imageUrl = "images/highridgeIntruder_small.webp",
                isAiText = false,
                isAiImage = false,
                aiHint = "Image, title, and description reference 'Bed Intruder' meme.",
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_026, 3, 21),
                veldekarDates = listOf("shimmer-20", "shimmer-21", "shimmer-22"),
            ),
            SessionListData.Full(
                path = "/2026-03-28",
                title = "Saturday Night Cleaver",
                description = "He is Frank Ettin, king of the discos (and kitchen knives). Every guy wants to dance like him. Every girl wants to be with him.",
                imageUrl = "images/saturdayNightCleaver_small.webp",
                isAiText = false,
                isAiImage = false,
                aiHint = "Image, title, and description are a joke.",
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_026, 3, 28),
                veldekarDates = listOf("shimmer-22"),
            ),
            SessionListData.Full(
                path = "/2026-04-11",
                title = "Cardigan of Defense",
                description = "The smoke is thick, the Balor is angry, and Bigglesworth is seconds away from inventing a new extreme sport. Even so, the heroes handle the crisis with the steady warmth of travelers who bring a little friendliness wherever they wander… even to a block currently full of giants.",
                imageUrl = "images/cardiganOfDefenseSocial_small.webp",
                isAiText = false,
                isAiImage = false,
                aiHint = "When Dirk said he takes cover “behind the cart again,” Caper misheard him saying “being the cardigan.” So the image show Dirk (from the campaign) hiding behind Fred Rogers (the host of a children's TV show in the real world known for wearing a cardigan). The title is a reference to this as well.",
                imageWidth = 520,
                imageHeight = 274,
                date = LocalDate(2_026, 4, 11),
                veldekarDates = listOf("shimmer-22", "shimmer-23", "shimmer-25"),
            ),
            SessionListData.Full(
                path = "/2026-04-18",
                title = "Dark Elves from The Mun",
                description = "The heroes learn that another band of adventurers also seeks the shard of Concar in the Gideon forest. But with Elrovir Rodiridan’s path seeking, the ability to scry shard locations, the good gods’ will, and even the favor of a few devils, the Friends of Forest are destined for victory.",
                imageUrl = "images/darkElvesFromTheMun_preview_small.webp",
                isAiText = false,
                isAiImage = false,
                aiHint = "The title is playing on the similarity between 'Mun' (a place in the campaign) and 'The Moon' (a natural satellite of Earth). The dark elves in the image are depicted as Sci-Fi characters referencing the play on words.",
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_026, 4, 18),
                veldekarDates = listOf("shimmer-25", "shimmer-26", "shimmer-27", "shimmer-29"),
            ),
            SessionListData.Full(
                path = "/2026-05-02",
                title = "Spirit Trolls Goin’ Down!",
                description = "On the same night that Spirit Airlines ceased operations and began liquidation, the heroes learned the weaknesses of the Spirit Trolls.",
                imageUrl = "images/spiritTrolls_small.webp",
                isAiText = false,
                isAiImage = false,
                aiHint = "The campaign involved 'Spirit Trolls' and the image, title and description twist that into 'Spirit Airlines' (a failed business in the real world) and Trolls (the dolls from the 90s).",
                imageWidth = 520,
                imageHeight = 274,
                date = LocalDate(2_026, 5, 2),
                veldekarDates = listOf("shimmer-29", "shimmer-30", "shimmer-31"),
            ),
            SessionListData.Full(
                path = "/2026-05-09",
                title = "I don’t think they saw us!",
                description = "The heroes evaded the surveillance and silenced the alarms. Caper brokered an unlikely alliance, and Dirk found love.",
                imageUrl = "images/eyeCamera_small.webp",
                isAiText = false,
                isAiImage = false,
                aiHint = "Image depicts a magical take on a modern (real world) camera and shouldn't be taken literally. The title and description are completely false (joke).",
                imageWidth = 520,
                imageHeight = 314,
                date = LocalDate(2_026, 5, 9),
                veldekarDates = listOf("shimmer-31"),
            ),
            SessionListData.Full(
                path = "/2026-05-23",
                title = "The Five Tabaxi Brothers",
                description = "Once upon a time, there were Five Tabaxi Brothers, and they all looked exactly alike. The First Tabaxi Brother could swallow the sea and collect all the “Feeshes.” The Second Tabaxi Brother was immune to venom, even from a Giant Scorpion. The Third Tabaxi Brother had an iron neck and could not be beheaded, even by a Vorpal Sword.",
                imageUrl = "images/TheFiveTabaxiBrothers_Preview_small.webp",
                isAiText = false,
                isAiImage = false,
                aiHint = "Image, title, and description compare the similarities between events in the campaign with the legend of the five Chinese brothers as depicted in the children's book.",
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_026, 5, 23),
                veldekarDates = listOf("shimmer-31"),
            ),
            SessionListData.Full(
                path = "/2026-05-30",
                title = "All Fun and Games Until Our Tools Become Self-Aware",
                description = "Annette is incapacitated by laughter while the Dino-twins Caper and Bigglesworth stomp the Drow to claim the shard of Concar. Is Bigglesworth’s new sentient blade, Razorwrath, a gift from the gods or the first seeds of the heroes’ destruction?",
                imageUrl = "images/AnnetteLaughingCaperDinoRazorwrath_small.webp",
                isAiText = false,
                isAiImage = false,
                aiHint = "Title references the similarity between the events in the campaign and the growing power of AI agents in the real world.",
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_026, 5, 30),
                veldekarDates = listOf("shimmer-31", "shimmer-32"),
            ),
            SessionListData.Full(
                path = "/2026-06-06",
                title = "Real-World Rogues Strike Again!",
                description = "Can't you just tell these pesky international criminals to stop? It's rude to get in the way of people's D&D campaigns!",
                imageUrl = "images/robberD20_preview_small.webp",
                isAiText = false,
                isAiImage = false,
                aiHint = "Image, title, and description are jokes but also reference the 'real world' not events in the D&D campaign.",
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_026, 6, 6),
                veldekarDates = listOf("shimmer-32"),
            ),
            SessionListData.Full(
                path = "/2026-08-01",
                title = "The Inevitable Breakup",
                description = "The heroes stage an intervention, ending Bigglesworth’s toxic relationship with Razorwrath.",
                imageUrl = "images/razorwrathGhosted_small.webp",
                isAiText = false,
                isAiImage = false,
                aiHint = "Image shows a smart-phone chat between a D&D character and a sword (joke). Image shows Bigglesworth as a ghost -- this is a reference to 'ghosting' and not meant to be taken literally.",
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_026, 8, 1),
                veldekarDates = listOf("shimmer-32", "shimmer-33"),
            ),
            SessionListData.Full(
                path = "/2026-08-08",
                title = "Dungeon Daddy Giveth",
                description = "Goram distributes gifts to the good boys and girls. The heroes hand over the cursed blade, Razorwrath, to Lord Fox before departing up river toward the Dwarven kingdom of Ladikor.",
                imageUrl = "images/goramSantaHat_small.webp",
                isAiText = false,
                isAiImage = false,
                aiHint = "Image shows Goram with a santa hat (joke). Goram is not actually called Dungeon Daddy (joke). Treant in picture is larger and more magical than it actually was.",
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_026, 8, 8),
                veldekarDates = listOf("shimmer-33", "shimmer-34"),
            ),
            SessionListData.Full(
                path = "/2026-08-29",
                title = "Setting the Record Straight",
                description = "A roc was never threatened by a Storm Giant or ominous clouds. The Friends of the Forest have not entered this territory. Unidentified Flying Bears? Truly, I can say there are, in fact, no UFBs anywhere.",
                imageUrl = "images/aroc_small.webp",
                isAiText = false,
                isAiImage = false,
                aiHint = "Image shows Baghdad Bob (meme). Title and description are the opposite of the truth.",
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_026, 8, 29),
                veldekarDates = listOf("shimmer-34", "shimmer-35", "shimmer-36", "shimmer-37"),
            ),
            SessionListData.Full(
                path = "/2026-09-12",
                title = "Bigglesworth Hungers!",
                description = "Between a Roc that got away and the mansion fish that vanished at the door, Bigglesworth is running on empty… and Annette is beginning to look delicious.",
                imageUrl = "images/meatOVision_small.webp",
                isAiText = false,
                isAiImage = false,
                aiHint = "The title and description suggesting Bigglesworth wants to eat Annette are a joke.",
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_026, 9, 12),
                veldekarDates = listOf("shimmer-37", "shimmer-38", "shimmer-39", "shimmer-42"),
            ),
            SessionListData.Full(
                path = "/2026-10-10",
                title = "I’m sorry Tuesday, but Minetrack Raccoon is in another castle.",
                description = "The heroes breach the sealed dwarven halls of Ladikor only to learn their contact in The Roving Peers, Midrack Vorkun isn’t there. He’s far to the south… unless he isn’t.",
                imageUrl = "images/raccoon_small.webp",
                isAiText = false,
                isAiImage = false,
                aiHint = "Minetrack Raccoon is not the contact's real name, and he's not actually an animal. He's likely a human or dwarf, but the players misheard his name.",
                imageWidth = 520,
                imageHeight = 273,
                date = LocalDate(2_026, 10, 10),
                veldekarDates = listOf("shimmer-43", "shimmer-44"),
            )
        )
